import { ReactNode, useMemo } from 'react';
import {
  useGetUserKycInfo,
  useHandleInitiateUserKyc,
  useHandleUpdateUserKyc,
} from '@package/smart-wallet/hooks';
import { useAuthStore } from '@package/smart-wallet/store';

import { KycContext } from './KycContext';

export const KycProvider = ({ children }: { children: ReactNode }) => {
  const id = useAuthStore((store) => store.id);

  /* Queries */
  const { kycUserInfo, isLoading: isLoadingKycUserInfo } = useGetUserKycInfo({
    id,
  });

  /* Update */
  useHandleUpdateUserKyc({
    id,
    kycUserInfo,
    isLoadingKycUserInfo,
  });

  /* Create */
  const {
    handleInitiateUserKyc,
    isLoading: isLoadingHandleInitiateUserKyc,
    error: errorHandleInitiateUserKyc,
  } = useHandleInitiateUserKyc({
    id,
    kycUserInfo,
    isLoadingKycUserInfo,
  });

  /* Memo */
  const kycUserError = useMemo(() => {
    return errorHandleInitiateUserKyc;
  }, [errorHandleInitiateUserKyc]);

  const isLoading = useMemo(() => {
    return isLoadingKycUserInfo || isLoadingHandleInitiateUserKyc;
  }, [isLoadingKycUserInfo, isLoadingHandleInitiateUserKyc]);

  /* Return */
  return (
    <KycContext.Provider
      value={{
        isLoading,
        kycUserInfo,
        kycUserError,
        handleInitiateUserKyc,
      }}
    >
      {children}
    </KycContext.Provider>
  );
};
